import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { AppConstants } from '../const/constent';
import { catchError, map, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '@app-services/auth-service/auth.service';
import { UserService } from '@app-services/user/user.service';
import { param } from 'jquery';
import { TenantConstant } from '@app-constants/tenant.constant';
import { LoginService } from '@app-services/login/login.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '@app-environments/environment';
import { apisDataCacheKeys } from '@app-constants/app.constants';
@Injectable({
  providedIn: 'root',
})
export class ClassService {
  apiURL = AppConstants.APIURL;
  baseApiURL = AppConstants.apiBaseUrl;
  cmsApi = AppConstants.cmsUrl;
  liveClassV2 = AppConstants.liveClassV2;
  tenant: any = TenantConstant.tenant;
  clearAllFilter = new BehaviorSubject<any>({val1: '', val2: false});
  allFilterClear = this.clearAllFilter.asObservable();
 recordId:any;
  ReWatchDataBody:any = {
    startedAt: 0,
    endedAt: 0,
    recordId: 0,
    startTime: ''
  };
  ReWatchDataParam:any= {
    classId: 0,
    studentId: 0
  };
  rewatchLogoClicked = new BehaviorSubject<boolean>(false);
  clickedRewatchLogo = this.rewatchLogoClicked.asObservable();
  liveClassPlaylistId: number;
  liveClassPlaylistName: string;
  liveClassPlaylistSingleVideoObj: any;
  liveClassPlaylistListOfVideoObj: any;
  constructor(
    private http: HttpClient,
    private route: Router,
    private authService: AuthService,
    public userService: UserService,
    private loginService: LoginService,
    private deviceService: DeviceDetectorService
  ) {}

  // private handleError(error: HttpErrorResponse): any {
  //   if (error.error instanceof ErrorEvent) {
  //     console.error('An error occurred:', error.error.message);
  //   } else {
  //     console.error(
  //       `Backend returned code ${error.status}, ` + `body was: ${error.error}`
  //     );
  //   }
  //   return throwError('Issure occure; please try again later.');
  // }
  private handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error?.error?.message);
    } else {
      if (error?.status == 401) {
        this.loginService.logoutEvent.emit();
      } else {
        console.error(
          `Backend returned code ${error?.status}, ` +
            `body was: ${error?.error?.message}`
        );
      }
    }
    return throwError('Issure occure; please try again later.');
  }

  studentHeader(param: any) {
    let headers: HttpHeaders = new HttpHeaders();

    if (param.customFilter) {
      Object.keys(param.customFilter.header).forEach((key) => {
        headers = headers.append(
          key,
          true
            ? JSON.stringify(param.customFilter?.header[key])
            : param.customFilter?.header[key]
        );
      });
    }
    return headers;
  }

  getOptions(param: any) {
    return new HttpParams({
      fromString: `filter=${param.filter ? param.filter : ''}&type=${
        param.type == 'recommended' ? 'featured' : param.type
      }&page=${param.page}&limit=${param.limit}`,
    });
  }

  getClasses(param: any) {
    const header = this.studentHeader(param);
    const options = this.getOptions(param);
    let opts;
    // if (param.type == 'recommended') {
    //   opts = {
    //     params: options
    //   }
    // } else {
    opts = {
      params: options,
      headers: header,
    };
    // }

    // let apiURL = (param?.customFilter?.header['ot-student']) ? this.apiURL.class : `${this.apiURL.class}/open`
    let apiURL = this.apiURL?.class;

    // this.http.get(apiURL, opts).subscribe((res: any) => { }, (err: any) => {
    //   this.handleError(err)
    // })

    return this.http.get(apiURL, opts);
  }

  generateHeader(filter: any) {
    if (!filter?.header) {
      return;
    } else {
      let headers: HttpHeaders = new HttpHeaders();
      Object.keys(filter.header).forEach((key) => {
        if (filter?.header[key] && filter?.header[key] != undefined) {
          headers = headers.append(
            key,
            true ? JSON.stringify(filter?.header[key]) : filter?.header[key]
          );
        }
      });
      return headers;
    }
  }

  getClassesList(param: any, userType?: number) {
    const header = this.generateHeader(param?.customFilter);
    // const options = this.getOptions(param);
    const options = this.getQueryParams(param?.customFilter?.filters);
    let opts;

    opts = {
      params: options,
      headers: header,
    };

    if (userType == 2) {
      let id = param?.customFilter?.header['ot-student'];
      return this.getTeacherClasses(id, param);
    } else {
      return this.http.get(this.apiURL.classList, opts);
    }
  }

  getClassDetails(classId: any) {
    return this.http.get(`${this.baseApiURL}eclasses/${classId}`);
  }

  checkClassEndStatus(classId: any) {
    return this.http.get(`${this.baseApiURL}eclasses/pulse/${classId}`);
  }

  getClassCount(param: any) {
    const header = this.generateHeader(param);
    let opts = {
      headers: header,
    };

    return this.http.get(`${this.apiURL.student}/count/myclasses`, opts);
  }

  classRegistre(id: any, userId: any) {
    let userData = this.userService.getMobileAndName();
    let body = {
      student: userId,
    };

    // this.http.post(`${this.baseApiURL}eclasses/${id}/register`, body).subscribe((res: any) => { }, (err: any) => {
    //   this.handleError(err)
    // })

    return this.http.post(`${this.baseApiURL}eclasses/${id}/register`, body);
  }

  isFirstTimeUser(id: any) {
    return this.http.get(`${this.apiURL.student}/${id}`);
  }

  syncStudent() {
    let value = this.userService.getMobileAndName();
    let roles = this.userService.getUserRoles()

    let data: any = {
      studentID:
        this.tenant == 'infinitylearn'
          ? value?.userId
          : value?.userId
          ? value.userId
          : localStorage.getItem('studentid'),
      firstName: value?.firstName,
      lastName: value?.lastName,
      grade: value?.grade,
      phone: value?.phone,
      email: value?.email,
      countryCode: value?.isdCode,
      userType: this.userService.getUserType(),
      profilePhoto: value?.profilePhoto,
      tenant: this.tenant,
      roles:roles? roles:[]
    };

    return this.http.post(`${this.baseApiURL}students/sync`, data).subscribe();
  }

  unSyncStudent(){
    let studentID = JSON.parse(localStorage.getItem('user_details_from_server'));
    studentID = studentID?.userId
    return this.http.delete(`${this.baseApiURL}students/${studentID}?isFromAdmin=true`);
  }
  getUserTotalClassDetail(id: any, param: any) {
    const header = this.generateHeader(param);
    let opts;

    opts = {
      headers: header,
    };
    return this.http.get(
      `${this.apiURL.student}/${id}/duration/myclasses`,
      opts
    );
  }

  getQueryParams(params: any) {
    let httpParams = new HttpParams();

    Object.keys(params).forEach((k) => {
      httpParams = httpParams.set(k, params[k]);
    });
    return httpParams;
  }

  getCourseClassesList(
    id: any,
    courseId: any,
    customFilter?: any,
    userTypeId: number = 1,
    isRecordedCourse?:boolean
  ) {

    let options = { params: this.getQueryParams(customFilter?.filters) };
    if (userTypeId == 1) {
      if(!isRecordedCourse){
      return this.http.get(
        `${this.apiURL.class}/student/${id}/course/${courseId}`,
        options
      );
      }else{
        return this.http.get(
          `${this.apiURL.class}/student/${id}/recorded-course/${courseId}`,options
        )
      }
    } else {
      return this.http.get(
        `${this.apiURL.teachers}/${id}/courses/${courseId}`,
        options
      );
    }
  }
  studentJoinSession(_formValues: any): Observable<any> {
    // const url = this.apiURL.student + `/${_formValues.userId}/class/${_formValues.classId}/${_formValues.zoom_id}?status=join`;
    const url =
      this.apiURL.student +
      `/${_formValues.userId}/class/${_formValues.classId}?platform=web&status=join`;
    return this.http.get(url);
  }

  studentJoinLeftSession(_formValues: any): Observable<any> {
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    _formValues['platform'] = isMobile == true ? 'mweb' : isTablet == true ? 'mweb' : isDesktopDevice == true ? 'web' : 'web';
    const url =
      this.apiURL.student +
      `/${_formValues.userId}/class/${_formValues.classId}?platform=${_formValues.platform}&status=${_formValues.status}`;
    return this.http.get(url);
  }

  getTeacherQueryParams = (params: any = null) => {
    let httpParams = new HttpParams();

    if (params && Object.keys(params).length > 0) {
      let _paramObj = Object.assign({}, params);

      if (Object.keys(_paramObj).includes('filter')) {
        _paramObj.type = params.filter;
        delete _paramObj.filter;
      }

      Object.keys(_paramObj).forEach((k) => {
        httpParams = httpParams.set(k, _paramObj[k]);
      });
    }
    return httpParams;
  };

  getTeacherClasses(teacherId: any, param: any) {
    // console.log("getTeacherClasses: ", param);
    // /teachers/609380c19dc708de33a77650/classes?type=past&limit=6&page=1
    const header = this.generateHeader(param?.customFilter);
    const options = this.getTeacherQueryParams(param?.customFilter?.filters);
    let opts;

    // headers: header
    opts = {
      params: options,
    };

    let url = `${this.apiURL.teachers}/${teacherId}/classes`;
    return this.http.get(url, opts);
  }

  getClassListFilter(type: string, customFilter?: any) {
    let userData = this.userService.getMobileAndName();
    let url = '';
    if (type == 'teacher') {
      url = `${this.apiURL.teachers}/classes/${userData?.userId}/filters`;
      return this.http.get(url);
    } else {
      const header = this.generateHeader(customFilter);
      const options = this.getQueryParams(customFilter?.filters);
      let opts;

      opts = {
        params: options,
        headers: header,
      };
      // /student/filters?filter=upcoming&type=eclass
      url = `${this.apiURL.class}/student/filters`;

      return this.http.get(url, opts);
    }
  }

  uploadMedia = (_classId: any, _formData: FormData) => {
    return this.http.post(
      `${this.baseApiURL}docs/class/${_classId}`,
      _formData
    );
  };

  renameClassDocument = (_params: any) => {
    return this.http.patch(
      `${this.baseApiURL}docs/${_params.docId}/class/${_params.classId}/type/${_params.type}`,
      { name: _params.name }
    );
  };

  removeClassDocument = (_params: any) => {
    return this.http.delete(
      `${this.baseApiURL}docs/${_params.docId}/class/${_params.classId}/type/${_params.type}`
    );
  };

  loadAllClasses = (
    _params: any,
    userTypeId: number = 1,
    userId: number = 0
  ) => {
    let apiOpts = {
      headers: this.generateHeader(_params),
      params: this.getQueryParams(_params?.filters),
    };
    if (userTypeId == 1) {
      return this.http.get(`${this.apiURL.class}/student/all`, apiOpts);
    } else {
      return this.http.get(
        `${this.apiURL.teachers}/${userId}/classes`,
        apiOpts
      );
    }
  };

  loadTeacherClassListFilter = (userId: number = 0, queryParams?: any) => {
    if (queryParams) {
      let options = { params: this.getQueryParams(queryParams) };
      return this.http.get(
        `${this.apiURL.teachers}/classes/${userId}/filters`,
        options
      );
    } else {
      return this.http.get(`${this.apiURL.teachers}/classes/${userId}/filters`);
    }
    // return this.http.get(`${this.apiURL.teachers}/classes/${userId}/filters`);
  };

  getListStatus(queryParams: any) {
    // ?type=courses&teacherUamID=222370
    let opts: any = { params: this.getQueryParams(queryParams) };
    return this.http.get(
      `${this.baseApiURL}common/class-and-course-oup-status`,
      opts
    );
  }

  getTeachers = () => {
    return this.http.get(this.apiURL.allTeachers);
  }

   /**
   * send rewtach data after 2 mins & 42 secs
   * @param queryParams
   * @param body
   */
    sendRewatchData(queryParams:any, body) {
      let opts: any = { params: this.getQueryParams(queryParams) };
      return this.http.put(
        `${this.baseApiURL}students/rewatch/${queryParams.studentId}/class/${queryParams.classId}`,
        body,
        opts
      );
  }

  getLiveClassPlaylist(gradeId: number, cmsExamId: number, tenantId: number, userId:number) {
    const url_ = this.cmsApi + `video_playlist/get/playlistsFor?gradeId=${gradeId}&examId=${cmsExamId}&playlistTypeId=3&status=Active&tenantId=${tenantId}`;
    let headers = {
      'accesstoken': localStorage.getItem('token'),
      'userId': `${userId}`,
      'x-platform':'web',
      'x-tenant': 'infinitylearn'
    };
    const header = headers;
    let opts;
    opts = {
      headers: header,
    };
    return this.http.get(url_,opts);
  }

  getLiveClassVideosByPlaylistId(playListId) {
    let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    let headers = {
      // 'student': localStorage.getItem('studentid'),
      'student': `${user?.userId}`
    };
    const header = headers;
    let opts;
    opts = {
      headers: header,
    };
    const url_ = this.liveClassV2 + `playlist/videos/${playListId}`;
    return this.http.get(url_,opts);
  }

  updateLiveClassPlaylistSingleVideo(body) {
    const url_ = this.liveClassV2 + `playlist`;
    let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    let seletedExam = JSON.parse(localStorage.getItem(apisDataCacheKeys.selectedExam));
    let gradeId =  user?.grade?.gradeId;
    let cmsDetails = environment.UAM_TO_CMS_CONVERSION?.find(ele => (seletedExam?.examId === ele?.UAM_exam_id) && gradeId === ele?.UAM_grade_id)

    body.metaData.examId = cmsDetails?.CMS_Exam_id;
    body.metaData.examName = seletedExam?.name;
    body.metaData.grade = parseInt(user?.grade?.name);

    return this.http.post(url_,body);
  }

  updateVideoProps(videoId, playListId, status: boolean, type: string) {
    let studentId = localStorage.getItem('studentid');
    let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    const url_ = this.liveClassV2 + `playlist/userActivity/${videoId}/${user?.userId}/${playListId}?value=${status}&type=${type}`;
    return this.http.put(url_,{});
  }
  reportVideo(){
    const url_ = this.liveClassV2 + `playlist/reports`;
    let body = {
      "videoId": "290108",
      "studentId": "290108",
      "reports": [
        {
          "title": "select all the issue(s) you faced",
          "issues": [
            {
              "label": "Incorrect Concept",
              "key": "incorrect_concept",
              "value": false
            },
            {
              "label": "Unclear Audio",
              "key": "unclear_audio",
              "value": false
            },
            {
              "label": "Unable To Play",
              "key": "unable_to_play",
              "value": false
            }
          ]
        },
        {
          "title": "error details if any",
          "issues": "Audio and Video content is not available"
        }
      ]
    }
    return this.http.post(url_,body);
  }

  countRewatchDetails(req, body){
    let student = req?.studentId;
    let classId= req?.classId
    const url = `${this.baseApiURL}students/rewatch/${student}/class/${classId}?classId=${classId}&studentId=${req.studentId}`
    return this.http.put(url,body)
  }

  getScoreClassList = (_params: any) => {
    let apiOpts = {
      headers: this.generateHeader(_params),
      params: this.getQueryParams(_params?.filters),
    };
    return this.http?.get(`${this.apiURL?.class}`, apiOpts);
  };

  getVideoData(videoId : string){
    return this.http.get(`${this.cmsApi}/videos/get_video/${videoId}`)
  }
}
